// Normalizes the handful of Arabic/Persian glyphs that render identically to a learner but
// compare unequal byte-for-byte, plus strips the zero-width non-joiner Farsi compound words
// often use. Applied at both search-index build time (scripts/build-search-index.js) and query
// time (GlobalSearch.js) so a query typed with either glyph variant still matches cached
// translations that happened to use the other one. Same dual Node/browser-loadable .mjs
// convention as translationPrompt.mjs/searchEntries.mjs — no framework imports.
//
// - Arabic yeh (U+064A ي) -> Persian yeh (U+06CC ی)
// - Arabic kaf (U+0643 ك) -> Persian keh (U+06A9 ک)
// - Zero-width non-joiner (U+200C) -> stripped (compound words like می‌خواهم vs میخواهم)
export function normalizeFarsi(str) {
  if (!str) return str;
  return str.replace(/ي/g, "ی").replace(/ك/g, "ک").replace(/‌/g, "");
}
